import React, { useEffect, useState } from 'react';
import { Outlet, Navigate } from "react-router-dom";

import { db, auth } from './firebase'
import { useAuthState } from 'react-firebase-hooks/auth';

import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";

export default function Root() {
    const [user, loading, error] = useAuthState(auth);
    // undefined = still loading the profile, object = loaded
    const [profile, setProfile] = useState(undefined);

    useEffect(() => {
        async function ensureProfile() {
            const ref = doc(db, "players", user.uid);
            const snap = await getDoc(ref);

            if (snap.exists()) {
                setProfile(snap.data());
                return;
            }

            // First sign-in: create the player profile keyed by auth uid.
            const displayName = user.displayName
                || (user.email ? user.email.split("@")[0] : "Player");
            const data = {
                displayName,
                email: user.email ?? "",
                createdAt: serverTimestamp(),
            };
            await setDoc(ref, data);
            setProfile(data);
        }

        if (user) {
            ensureProfile();
        }
    }, [user]);

    if (loading) {
        return <p>Loading…</p>;
    }
    if (error) {
        return <p>Sign-in error: {error.message}</p>;
    }
    if (!user) {
        return <Navigate to="/login" />;
    }
    if (profile === undefined) {
        return <p>Loading…</p>;
    }

    return (
        <div id="playroot">
            <Outlet context={{ uid: user.uid, profile }} />
        </div>
    );
}
